import {Alert, Typography} from "@mui/material";
import React from "react";
import {OptionGroup, PrepOption} from "../PrepMenuOptions";
import {PrepMenu} from "./PrepMenu";
import {useFixer} from "./Fixer";

export function DoorAndFrame(props: {
    value: PrepOption;
    group: OptionGroup;
    onChange(v: Partial<PrepOption>): void;
}) {
    const fix = useFixer({
        value: props.value,
        autoFix: (v) => autoFixFrame(autoFixDoor(v)),
        onChange: props.onChange,
    });

    console.log("prep", props.group);

    return (
        <>
            <Typography variant="body2">HW Preps</Typography>
            <div style={{height: 8}}/>
            <PrepMenu id="single-frame" name="Frame"
                      value={props.value}
                      editKey="singleFramePrep" editKeyCustom="singleFramePrepCustomTemplate"
                      editKeyCustomName="singleFramePrepCustomTemplateName"
                      groupKey="singleFramePreps" groupCustomKey="singleFramePrepsCustom"
                      group={props.group} onChange={v => props.onChange(autoFixFrame(v))} />
            <div style={{height: 8}}/>
            <PrepMenu id="single-active" name="Door"
                      value={props.value}
                      editKey="singleActiveDoorPrep" editKeyCustom="singleActiveDoorPrepCustomTemplate"
                      editKeyCustomName="singleActiveDoorPrepCustomTemplateName"
                      groupKey="singleActiveDoorPreps" groupCustomKey="singleActiveDoorPrepsCustom"
                      group={props.group} onChange={v => props.onChange(autoFixDoor(v))}/>

            {fix && <Alert severity="warning" style={{marginTop: 8, marginBottom: 8}}>
                Some background properties need to update. Please save product when you're done.
            </Alert>}
        </>
    )
}

function autoFixFrame(v: Partial<PrepOption>): Partial<PrepOption> {
    const obj: Partial<PrepOption> = {
        ...v,
    }

    // copy to pair too
    if(obj.hasOwnProperty("singleFramePrep")) {
        obj.pairFramePrep = obj.singleFramePrep;
    }

    if(obj.hasOwnProperty("singleFramePrepCustomTemplate")) {
        obj.pairFramePrepCustomTemplate = obj.singleFramePrepCustomTemplate;
        obj.pairFramePrepCustomTemplateName = obj.singleFramePrepCustomTemplateName;
    }

    return obj;
}

function autoFixDoor(v: Partial<PrepOption>): Partial<PrepOption> {
    const obj: Partial<PrepOption> = {
        ...v,
    }

    // copy to pairActive and pairInActive
    if(obj.hasOwnProperty("singleActiveDoorPrep")) {
        obj.pairActiveDoorPrep = obj.singleActiveDoorPrep;
        obj.pairInactiveDoorPrep = obj.singleActiveDoorPrep;
        obj.pairBothActiveDoorPrep = obj.singleActiveDoorPrep;
    }

    if(obj.hasOwnProperty("singleActiveDoorPrepCustomTemplate")) {
        obj.pairActiveDoorPrepCustomTemplate = obj.singleActiveDoorPrepCustomTemplate
        obj.pairActiveDoorPrepCustomTemplateName = obj.singleActiveDoorPrepCustomTemplateName
        obj.pairInactiveDoorPrepCustomTemplate = obj.singleActiveDoorPrepCustomTemplate
        obj.pairInactiveDoorPrepCustomTemplateName = obj.singleActiveDoorPrepCustomTemplateName
        obj.pairBothActiveDoorPrepCustomTemplate = obj.singleActiveDoorPrepCustomTemplate
        obj.pairBothActiveDoorPrepCustomTemplateName = obj.singleActiveDoorPrepCustomTemplateName
    }

    return obj;
}